import { Configuration, PopupRequest } from '@azure/msal-browser';

const mslclientid: string = process.env.REACT_APP_MSL_CLIENTID ?? '';

export const msalConfig: Configuration = {
    auth: {
        clientId: mslclientid,
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: window.location.origin + '/login',
        postLogoutRedirectUri: window.location.origin + '/login',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0,
    }
};

export const loginRequest: PopupRequest = {
    scopes: ['User.Read', 'openid', 'profile', 'email'],
    prompt: 'select_account',
};